const Validator = {
    isObject: (x) => {
        return typeof x === 'object' && !Array.isArray(x) && x !== null;
    },
    isValidJson: (jsonString) => {
        if (typeof jsonString !== 'string') {
            return false; // Not a string
        }

        try {
            JSON.parse(jsonString); // Attempt to parse the JSON string
            return true; // If successful, return true
        } catch (e) {
            return false; // If an error is thrown, return false
        }
    }
};

export default Validator;
